export default __webpack_public_path__ + "static/shopback_2-88f5419f8cba4fe580e28f308f5e22f0.jpg";